export default __webpack_public_path__ + "static/media/strikepay_Mark_url_RGB_White.eb6ce341.png";